var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueBlur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1859,
    height: 1859,
    viewBox: "0 0 1859 1859",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    filter: "url(#filter0_f_361_204)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 929.5,
    cy: 929.5,
    r: 329.5,
    fill: "#7E3BD7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_361_204",
    x: 0,
    y: 0,
    width: 1859,
    height: 1859,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 300,
    result: "effect1_foregroundBlur_361_204"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBlur);
export default __webpack_public_path__ + "static/media/blue-blur.2f2c0caec448b42f0e216c9a9fab44f0.svg";
export { ForwardRef as ReactComponent };